import { apiFetch } from './client';
import type { DeviceRow } from '$lib/types';

// hrDevicesApi is the RequireHR-gated device directory at /api/hr/devices —
// list every user's device-binding status and reset (delete) one so its
// owner can re-register on next login.
export const hrDevicesApi = {
  list: () => apiFetch<DeviceRow[]>('/hr/devices'),
  reset: (userId: number) => apiFetch<{ detail: string }>(`/hr/devices/${userId}/reset`, { method: 'POST' })
};
